import CorporateMembershipReportView from '../../features/MetabaseDashboard/CorporateMembershipReportView '

const CorporateMembershipReport = () => {
  return (
    <div><CorporateMembershipReportView /></div>
  )
}

export default CorporateMembershipReport